"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const GuidesHide_1 = __importStar(require("../../molecules/GuidesHide"));
const GuidesProvider_1 = require("../../providers/GuidesProvider");
const device_1 = require("@completeanatomy/device");
const tools_1 = require("../../utils/tools");
function GuidesPanel({ selectedToolType }) {
    const [{ isGuidesAvailable, isGuidesExpanded, isGuidesVisible, guidesGridWidth, isHideGuidesPanel, },] = (0, GuidesProvider_1.useGuidesContext)();
    const { isWindows } = (0, device_1.usePlatform)();
    if (!isGuidesAvailable && (0, tools_1.is2DTool)(selectedToolType)) {
        return null;
    }
    /* set panel to center between grid and window center */
    const allowSpaceWidth = (document.body.clientWidth / 2 - guidesGridWidth) / 2;
    const panelOffset = guidesGridWidth + allowSpaceWidth - GuidesHide_1.PANEL_WIDTH / 2;
    const isVisible = isGuidesExpanded && isGuidesVisible;
    const isGuidesPanelVisible = isVisible && !isHideGuidesPanel;
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'GuidesPanel_Container', children: [(0, jsx_runtime_1.jsx)(LeftGrid, { visible: isVisible, width: guidesGridWidth, windows: isWindows, "data-e2e": 'GuidesPanel_LeftGrid' }), (0, jsx_runtime_1.jsx)(RightGrid, { visible: isVisible, width: guidesGridWidth, windows: isWindows, "data-e2e": 'GuidesPanel_RightGrid' }), (0, jsx_runtime_1.jsx)(StyledGuidesHidePanel, { visible: isGuidesPanelVisible, offset: panelOffset, selectedToolType: selectedToolType, "data-e2e": 'GuidesPanel_StyledGuidesHidePanel' })] }));
}
exports.default = GuidesPanel;
const Container = styled_components_1.default.div.attrs({ role: 'dialog' }) `
  position: absolute;
  top: 0;
  left: 0;

  width: 100vw;
  height: 100vh;

  pointer-events: none;
`;
const Grid = styled_components_1.default.div `
  position: absolute;
  top: 0;
  bottom: 0;

  width: ${({ width }) => width}px;

  transition: transform 0.3s;

  &::before {
    position: absolute;

    width: 100%;
    height: 100%;

    background-size: 20px 20px;

    content: '';
  }
`;
const LeftGrid = (0, styled_components_1.default)(Grid) `
  left: 0;

  transform: scaleX(-1) translateX(${({ visible }) => (visible ? 0 : '130%')});

  &::before {
    background-image: ${({ theme, windows }) => windows ? theme.tools.guides.lineLeftWin : theme.tools.guides.lineLeft};
    border-left: 1px solid ${({ theme }) => theme.notifications.buttonShadow};
  }
`;
const RightGrid = (0, styled_components_1.default)(Grid) `
  right: 0;

  transform: translateX(${({ visible }) => (visible ? 0 : '130%')});

  &::before {
    background-image: ${({ theme, windows }) => windows ? theme.tools.guides.lineRightWin : theme.tools.guides.lineRight};
  }
`;
const StyledGuidesHidePanel = (0, styled_components_1.default)(GuidesHide_1.default) `
  position: absolute;
  bottom: 20px;
  left: ${({ offset }) => offset}px;

  z-index: 10;

  transform: translateY(${({ visible }) => (visible ? 0 : '130%')});

  transition: transform 0.3s;

  pointer-events: initial;
`;
